import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import Moment from 'react-moment';
import ModalRenewHistory from "../modal_renewhistory/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import queryString from "query-string";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {agentRegister} from "../../services/agentRegister";

class userCampaignsHistoryEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            renewLoader: false,
            renewModal: false,
            advertising_name: null,
            budget: null,
            currency: null,
            email: null,
            id: null,
            industry: null,
            landingpage: null,
            landingepage_address: null,
            landingpage_advertiser: null,
            landingpage_email: null,
            landingpage_phone: null,
            landingpage_url: null,
            language: null,
            website: null,
            phone: null,
            regions: null,
            related_industries: null,
            invoice_hash: null,
            renew: null,
            end_date: null,
            target_slogan: null,
            facebook_demographics: null,
            tab: "campaign",
            sub_tab: "general",
            keyword_languages: {},
            restart: false,
            landing_extra: {},
            smart_spend: false,
            reactions: {},
            video_url: "",
            video_thumbnail: "",
            facebook_canvas: "",
            instagram_canvas: "",
            landingpage_lat: null,
            landingpage_lng: null,
            carousel_ads: [],
            branding_pref: [],
            impressions: null,
            slogans: [],
            facebook_feed_status: false,
            google_feed_status: false,
            tiktok_feed_status: false,
            snapchat_feed_status: false,
            isLoadingFeed: true,
            feeds: false,
            feed_channels: ["fb", "google"]
        };
        this._autoRenew = this._autoRenew.bind(this);
    }

    componentWillMount() {
        try {
            this.setState({hash: this.props.match.params.hash}, () => {
                this._updateCampaign();
            });
        } catch (e) {
        }

        //REDIRECT LANDING PAGE LEADS
        try{
            let query = queryString.parse(this.props.location.search);
            if(query.leads){
                this.setState({
                    tab: "landingpage",
                    sub_tab: "leads"
                })
            }
        }catch (e) {}

        //REDIRECT LANDING PAGE ENGAGEMENT
        try{
            let query = queryString.parse(this.props.location.search);
            if(query.engagement){
                this.setState({
                    tab: "landingpage",
                    sub_tab: "activity"
                })
            }
        }catch (e) {}

        //REDIRECT CAMPAIGN REACTIONS
        try{
            let query = queryString.parse(this.props.location.search);
            if(query.reactions){
                this.setState({
                    tab: "campaign",
                    sub_tab: "activity"
                })
            }
        }catch (e) {}

    }

    _checkQuery() {
        let query = queryString.parse(this.props.location.search);
        if (query.modal && !this.state.renew) {
            this._setRenew();
        }
    }

    _updateCampaign() {
        dataRegister.singleCampaign(salesChannelRegister.get('market'), langRegister.lang(), this.state.hash).then((response) => {
            if (!response.errors) {
                this._setValues(response);
                this._updateUserData();
            }
        }, (error) => {
        });
    }

    _updateUserData() {
        let user = userRegister.get();
        if (user) {
            if (user.socialData) {
                this.setState({
                    feeds: user.socialData.feeds ? user.socialData.feeds : false
                }, () => {
                    if (this.state.feeds) {
                        this._updateFeedData();
                    }
                });
            }
        }
    }

    _updateFeedData() {
        dataRegister.account(salesChannelRegister.get('market')).then((response) => {
            if (response.feed_pref) {
                this.setState({
                    facebook_feed_status: response.feed_pref.facebook_remarketing.status ? response.feed_pref.facebook_remarketing.status : false,
                    google_feed_status: response.feed_pref.google_remarketing.status ? response.feed_pref.google_remarketing.status : false,
                    tiktok_feed_status: response.feed_pref.tiktok_remarketing.status ? response.feed_pref.tiktok_remarketing.status : false,
                    snapchat_feed_status: response.feed_pref.snapchat_remarketing.status ? response.feed_pref.snapchat_remarketing.status : false,
                }, () => {
                    this._renderFeeds();
                });
            } else {
                this._renderFeeds();
            }
        }, (error) => {
            this.setState({
                feed_pref: false,
                isLoadingFeed: false
            });
        });
    }

    _renderFeeds() {

        let feed_channels = [];
        if (this.state.facebook_feed_status)
        {
            feed_channels.push("fb");
        }
        if (this.state.google_feed_status)
        {
            feed_channels.push("google");
        }
        if (this.state.tiktok_feed_status)
        {
            feed_channels.push("tiktok");
        }
        if (this.state.snapchat_feed_status)
        {
            feed_channels.push("snapchat");
        }

        this.setState({
            feed_channels: feed_channels
        }, () => {
            this.setState({isLoadingFeed: false})
        });
    }

    _setValues(data) {
        this.state.advertising_name = data.advertising_name ? data.advertising_name : "";
        this.state.budget = data.budget_per_channel ? data.budget_per_channel : {};
        this.state.currency = data.currency ? data.currency : "";
        this.state.email = data.email ? data.email : "";
        this.state.optimization = data.optimization ? +data.optimization : "";
        this.state.id = data.id ? data.id : "";
        this.state.industry = data.industry ? data.industry : "";
        this.state.website = data.website ? data.website : null;
        this.state.landingpage = data.landingpage ? data.landingpage : null;
        this.state.landingepage_address = data.landingepage_address ? data.landingepage_address : "";
        this.state.landingpage_advertiser = data.landingpage_advertiser ? data.landingpage_advertiser : "";
        this.state.landingpage_email = data.landingpage_email ? data.landingpage_email : "";
        this.state.landingpage_phone = data.landingpage_phone ? data.landingpage_phone : "";
        this.state.landingpage_url = data.landingpage_url ? data.landingpage_url : "";
        this.state.language = data.language ? data.language : "";
        this.state.phone = data.phone ? data.phone : "";
        this.state.regions = data.regions ? data.regions : {};
        this.state.related_industries = data.related_industries ? data.related_industries : [];
        this.state.facebook_demographics = data.facebook_demographics ? data.facebook_demographics : {};
        this.state.target_slogan = data.target_slogan ? data.target_slogan : null;
        this.state.duration = data.duration ? data.duration : "";
        this.state.renew = data.renew;
        this.state.end_date = data.end_date;
        this.state.invoice_hash = data.invoice_hash;
        this.state.keyword_languages = data.keyword_languages ? data.keyword_languages : {};
        this.state.restart = data.restart ? data.restart : false;
        this.state.landing_extra = data.landing_extra ? data.landing_extra : false;
        this.state.smart_spend = data.smart_spend ? data.smart_spend : false;
        this.state.reactions = data.reactions ? data.reactions : "";
        this.state.carousel_ads = data.carousel_ads ? data.carousel_ads : false;
        this.state.branding_pref = data.branding_pref ? data.branding_pref : false;
        this.state.landingpage_lat = data.landingpage_lat ? data.landingpage_lat : null;
        this.state.landingpage_lng = data.landingpage_lng ? data.landingpage_lng : null;
        this.state.impressions = data.impressions ? data.impressions : "";
        this.state.slogans = data.slogans ? data.slogans : false;
        try {
            if (data.video) {
                this.state.video_url = data.video.url ? data.video.url : "";
                this.state.video_thumbnail = data.video.thumbnail ? data.video.thumbnail : "";
            }
        } catch (e) {
        }
        try {
            if (data.image) {
                this.state.facebook_canvas = data.image.fb.feed ? data.image.fb.feed : "";
                this.state.instagram_canvas = data.image.instagram.feed ? data.image.instagram.feed : "";
            }
        } catch (e) {
        }
        if(data.landingpage_data){
            this.state.landing_status = !data.landingpage_data.expired;
            this.state.landing_id = data.landingpage_data.id;
        }

        this.setState({
            landing_id: this.state.landing_id,
            landing_status: this.state.landing_status,
            landing_extra: this.state.landing_extra,
            advertising_name: this.state.advertising_name,
            budget: this.state.budget,
            currency: this.state.currency,
            email: this.state.email,
            id: this.state.id,
            industry: this.state.industry,
            website: this.state.website,
            landingpage: this.state.landingpage,
            landingepage_address: this.state.landingepage_address,
            landingpage_advertiser: this.state.landingpage_advertiser,
            landingpage_email: this.state.landingpage_email,
            landingpage_phone: this.state.landingpage_phone,
            landingpage_url: this.state.landingpage_url,
            language: this.state.language,
            phone: this.state.phone,
            regions: this.state.regions,
            related_industries: this.state.related_industries,
            facebook_demographics: this.state.facebook_demographics,
            end_date: this.state.end_date,
            renew: this.state.renew !== 0,
            target_slogan: this.state.target_slogan,
            invoice_hash: this.state.invoice_hash,
            isLoading: false,
            keyword_languages: this.state.keyword_languages,
            restart: this.state.restart,
            smart_spend: this.state.smart_spend,
            reactions: this.state.reactions,
            video_url: this.state.video_url,
            video_thumbnail: this.state.video_thumbnail,
            facebook_canvas: this.state.facebook_canvas,
            instagram_canvas: this.state.instagram_canvas,
            landingpage_lat: this.state.landingpage_lat,
            landingpage_lng: this.state.landingpage_lng,
            carousel_ads: this.state.carousel_ads,
            branding_pref: this.state.branding_pref,
            impressions: this.state.impressions,
            slogans: this.state.slogans
        }, () => {

            this._checkQuery();

            try {
                if((Object.keys(this.state.facebook_demographics).length === 0 && this.state.facebook_demographics.constructor === Object) && (this.renderKeywordLanguages().length > 1 || this.state.target_slogan)){
                    this.state.facebook_demographics = {};
                    this.state.facebook_demographics.target_slogan = this.state.target_slogan;
                    this.state.facebook_demographics.keywords = this.renderKeywordLanguages();
                    this.setState({facebook_demographics: this.state.facebook_demographics});
                }else if(Object.keys(this.state.facebook_demographics).length !== 0 && this.state.facebook_demographics.constructor === Object){
                    this.state.facebook_demographics.target_slogan = this.state.target_slogan;
                    this.state.facebook_demographics.keywords = this.renderKeywordLanguages();
                    this.setState({facebook_demographics: this.state.facebook_demographics});
                }else{
                    this.setState({facebook_demographics: null});
                }
            }catch (e) {}

        });
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        agentRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _goLanding() {
        if (this.state.landingpage) {
            try {
                window.open("https://lp." + dataRegister.domain + "/" + this.state.landingpage_url, '_blank');
            } catch (error) {
            }
        } else if (this.state.website) {
            try {
                window.open(this.state.website, '_blank');
            } catch (error) {
            }
        }
    }

    _autoRenew(value) {
        if (value) {

            //GOOGLE EVENT
            if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                ReactGA.event({category: 'User', action: 'Restarted Campaign', label: 'User'});
                ReactGA4.event({category: 'User', action: 'Restarted Campaign', label: 'User'});
            }

            //console.log("restart true");

            //FACEBOOK EVENT
            if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                ReactPixel.trackCustom('RestartCampaign');
            }

            this.setState({renewLoader: true, renewModal: false});
            dataRegister.renew(salesChannelRegister.get('market'), this.props.match.params.hash, {auto_renew: false, restart: true}).then((response) => {
                if (!response.errors) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running");
                    this.setState({renewLoader: false, renew: false});
                } else {
                    this.setState({renewLoader: false});
                }
            }, (error) => {
                this.setState({renewLoader: false});
            });
        } else {
            this.setState({renewModal: false});
        }
    }

    _setRenew() {
        this.setState({renewModal: true});
    }

    _selectInvoice() {
        window.open("https://invoice." + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + this.state.invoice_hash, '_blank');
    }

    _selectSummary() {
        window.open("https://confirmation." + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + this.props.match.params.hash, '_blank');
    }

    _selectReport() {
        window.open("https://report." + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + this.props.match.params.hash, '_blank');
    }

    _back() {
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/history");
    }

    _renderSex(value) {
        if (value === "m") {
            return langRegister.lang() === "sv" ? "Män" : "Male"
        } else if (value === "f") {
            return langRegister.lang() === "sv" ? "Kvinnor" : "Female"
        }
    }

    _renderLang(lang) {
        if (lang === "sv") {
            return langRegister.lang() === "sv" ? "Svenska" : "Swedish"
        } else if (lang === "en") {
            return langRegister.lang() === "sv" ? "Engelska" : "English"
        }
    }

    _renderChannel(channel) {
        if (channel === "fb") {
            return "facebook"
        } else {
            return channel;
        }
    }

    _renderIcon(key) {
        if(key === 'fb' || key === 'facebook' || key === 'bing' || key === 'instagram' || key === 'google' || key === 'pb' || key === 'yl' || key === 'bb' || key === 'tiktok' || key === 'snapchat' || key === 'proptree'){
            if(salesChannelRegister.get("name") === "yieldlock"){
                let color = "#00273A";
                if(key === "facebook"){
                    key = "fb";
                }
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div style={{backgroundColor: color, marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }else if(salesChannelRegister.get("name") === "propertybooster"){
                let color = "#000000";
                if(key === "facebook"){
                    key = "fb";
                }
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div style={{backgroundColor: color, marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }else if(salesChannelRegister.get("name") === "boostabostad"){
                let color = "#000000";
                if(key === "facebook"){
                    key = "fb";
                }
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div style={{backgroundColor: color, marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }else{
                let color = "cardSubtitleInnerIconsItemColor" + key;
                let size = "cardSubtitleInnerIconsItem" + key;
                return (
                    <div className={
                        cx(Styles.cardSubtitleInnerIconsItem,
                            {
                                [Styles[color]]: this.state.open
                            })
                    }>
                        <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                    </div>
                )
            }
        }
    }

    renderKeywordLanguages(){
        let list = [];
        try {
            if(this.state.keyword_languages.google && this.state.keyword_languages.bing){
                list = this.state.keyword_languages.google.concat(this.state.keyword_languages.bing);
                const final = [];
                list.map((e,i)=> !final.includes(e) && final.push(e) );
                list = final;
            }else if(this.state.keyword_languages.google && !this.state.keyword_languages.bing){
                list = this.state.keyword_languages.google;
            }else if(!this.state.keyword_languages.google && this.state.keyword_languages.bing){
                list = this.state.keyword_languages.bing;
            }
            return list;
        }catch (e) {
            return list;
        }
    }

    renderKeywordLanguageTitle(item){
        let items = {
            'en': {'en': 'English', 'sv': 'Engelska'},
            'ar': {'en': 'Arabic', 'sv': 'Arabiska'},
            'fi': {'en': 'Finnish', 'sv': 'Finska'},
            'de': {'en': 'German', 'sv': 'Tyska'},
            'zh': {'en': 'Chinese', 'sv': 'Kinesiska'},
            'tr': {'en': 'Turkish', 'sv': 'Turkiska'},
            'es': {'en': 'Spanish', 'sv': 'Spanska'},
            'el': {'en': 'Greek', 'sv': 'Grekiska'},
            'sv': {'en': 'Swedish', 'sv': 'Svenska'},
            'cs': {'en': 'Czech', 'sv': 'Tjeckiska'},
            'da': {'en': 'Danish', 'sv': 'Danska'},
            'mt': {'en': 'Maltese', 'sv': 'Maltesiska'},
            'hr': {'en': 'Croatian', 'sv': 'Kroatiska'},
            'pa': {'en': 'Punjabi', 'sv': 'Punjabi'},
            'fr': {'en': 'French', 'sv': 'Franska'},
            'nl': {'en': 'Dutch', 'sv': 'Holländska'},
            'ko': {'en': 'Korean', 'sv': 'Koreanska'},
            'hi': {'en': 'Hindi', 'sv': 'Hindi'},
            'pt': {'en': 'Portuguese', 'sv': 'Portugisiska'},
            'ur': {'en': 'Urdu', 'sv': 'Urdu'},
            'it': {'en': 'Italian', 'sv': 'Italienska'},
            'ru': {'en': 'Russian', 'sv': 'Ryska'},
            'pl': {'en': 'Polish', 'sv': 'Polska'},
            'ja': {'en': 'Japanese', 'sv': 'Japanska'},
            'sr': {'en': 'Serbian', 'sv': 'Serbiska'},
            'ms': {'en': 'Malay', 'sv': 'Malay'}
        };
        try {
            return items[item][langRegister.lang()];
        }catch (e) {
            return item;
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderChannelName(item){
        if(item === "facebook"){
            return "Facebook social"
        }else if(item === "instagram"){
            return "Instagram social"
        }else if(item === "google"){
            return "Google search"
        }else if(item === "bing"){
            return "Bing search"
        }
    }

    _renderFeedChannelName(item) {
        console.log(item);
        if (item === "fb") {
            return "Facebook networks"
        } else if (item === "instagram") {
            return "Instagram social"
        } else if (item === "google") {
            return "Google display"
        } else if (item === "bing") {
            return "Bing display"
        } else if (item === "tiktok") {
            return "TikTok networks"
        } else if (item === "snapchat") {
            return "Snapchat networks"
        }
    }

    _renderText(item) {
        return langRegister.get("user-campaigns-history-edit", item);
    }

    _getYieldlockData(type){
        var getUrl = window.location;
        var test = getUrl.href;
        test = test.replace('user/campaigns/history/' + this.props.match.params.hash, 'pdf/yieldlock?');
        if(this.state.landing_extra.yieldlock){
            let data = {
                type: type === 'buyer'?"buyer":this.state.landing_extra.yieldlock.type,
                amenities: this.state.landing_extra.yieldlock.amenities,
                lat: this.state.landing_extra.yieldlock.lat,
                lng: this.state.landing_extra.yieldlock.lng,
                location: this.state.landing_extra.yieldlock.location,
                industry: this.state.landing_extra.yieldlock.industry,
                beds: this.state.landing_extra.yieldlock.beds,
                property_type: this.state.landing_extra.yieldlock.property_type,
                property_status: this.state.landing_extra.yieldlock.property_status,
                baths: this.state.landing_extra.yieldlock.baths,
                sqft: this.state.landing_extra.yieldlock.sqft,
                sqm: this.state.landing_extra.yieldlock.sqm,
                image: this.state.landing_extra.yieldlock.image,
                market_rent: this.state.landing_extra.yieldlock.market_rent,
                list_rent: this.state.landing_extra.yieldlock.rent_boost,
                market_price: this.state.landing_extra.yieldlock.market_price,
                years: this.state.landing_extra.yieldlock.years,
                list_price: this.state.landing_extra.yieldlock.list_price,
                yield: this.state.landing_extra.yieldlock.yield,
                up_front: this.state.landing_extra.yieldlock.upfront,
                currency: this.state.landing_extra.yieldlock.currency,
                broker_image: null,//typeof this.state.user === 'object'?this.state.user.profile_image:null,
                broker_email: null, //typeof this.state.user === 'object'?this.state.user.email:null,
                broker_phone: null, //typeof this.state.user === 'object'?this.state.user.phone:null,
                broker_name: null, //typeof this.state.user === 'object'?(this.state.user.name + " " + this.state.user.surname):null
            };

            let user = userRegister.get();
            if (user) {
                data.broker_image = user.profile_image;
                data.broker_email = user.email;
                data.broker_phone = user.phone;
                data.broker_name = user.name + " " + user.surname;
            }

            let query = queryString.stringify(data);
            test = test + query;
            window.open(test);
        }
    }

    _getBoosterData() {
        var getUrl = window.location;
        var test = getUrl.href;
        test = test.replace('user/campaigns/history/' + this.props.match.params.hash, 'pdf/booster?');
        if (this.state.landing_extra) {
            let data = {
                slogans: this.state.slogans,
                slogan_0: this.state.slogans[0]? this.state.slogans[0] : null,
                slogan_1: this.state.slogans[1]? this.state.slogans[1] : null,
                slogan_2: this.state.slogans[2]? this.state.slogans[2] : null,
                slogan_3: this.state.slogans[3]? this.state.slogans[3] : null,
                impressions: this.state.impressions,
                lat: this.state.landingpage_lat,
                lng: this.state.landingpage_lng,
                landingpage_url: this.state.landingpage_url,
                landingepage_address: this.state.landingepage_address,
                carousel_ads: [],
                branding_pref: null,
                branding_primary: null,
                branding_secondary: null,
                engagement: this.state.landing_extra.engagement ? this.state.landing_extra.engagement.length : null,
                type: this.state.landing_extra.identifier,
                duration: this.state.landing_extra.duration,
                amenities: this.state.landing_extra.amenities,
                location: this.state.landing_extra.location,
                industry: this.state.landing_extra.industry,
                beds: this.state.landing_extra.beds,
                property_type: this.state.landing_extra.identifier,
                property_status: this.state.landing_extra.completion_status ? this.state.landing_extra.completion_status : null,
                furnishings: this.state.landing_extra.furnishings ? this.state.landing_extra.furnishings : null,
                just_listed: this.state.landing_extra.just_listed ? this.state.landing_extra.just_listed : null,
                price_change: this.state.landing_extra.price_change ? this.state.landing_extra.price_change : null,
                old_price: this.state.landing_extra.old_price ? this.state.landing_extra.old_price : null,
                baths: this.state.landing_extra.baths,
                sqft: this.state.landing_extra.area_sqft,
                image: this.state.landing_extra.image0,
                list_price: this.state.landing_extra.price,
                currency: this.state.landing_extra.currency_ads,
                broker_image: this.state.landing_extra.landingpage_profile_image ? this.state.landing_extra.landingpage_profile_image : null,
                broker_email: null,
                broker_phone: null,
                broker_name: null,
                broker_company: null,
                broker_permit: null,
                broker_whatsapp: null,
                broker_logo: null,
                broker_ref: null
            };

            try {
                if (this.state.landing_extra.description && this.state.landing_extra.description.length > 25) {
                    data.description = this.state.landing_extra.description;
                }
            } catch (e) {
            }

            if (this.state.reactions) {
                data.reactions = [];
                data.reactions = this.state.reactions ? this.state.reactions.length : null;
            }

            if (this.state.carousel_ads) {
                data.carousel_ads = [];
                for (let i = 1; i < this.state.carousel_ads.length; i++) {
                    data.carousel_ads.push(this.state.carousel_ads[i].image);
                }
            }

            if (this.state.landing_extra.broker) {
                data.broker_email = this.state.landing_extra.broker.email;
                data.broker_phone = this.state.landing_extra.broker.phone;
                data.broker_name = this.state.landing_extra.broker.name;
                data.broker_company = this.state.landing_extra.broker.company? this.state.landing_extra.broker.company : null;
                data.broker_permit = this.state.landing_extra.broker.brn? this.state.landing_extra.broker.brn : null;
                data.broker_whatsapp = this.state.landing_extra.broker.whatsapp? this.state.landing_extra.broker.whatsapp : null;
                data.broker_ref = this.state.landing_extra.broker.ref? this.state.landing_extra.broker.ref : null;
            }

            if (this.state.landing_extra.branding_pref && this.state.landing_extra.branding_pref[0] && this.state.landing_extra.branding_pref[0] !== "") {
                data.branding_pref = true;
                data.branding_primary = this.state.landing_extra.branding_pref[0]? this.state.landing_extra.branding_pref[0] : "";
                data.branding_secondary = this.state.landing_extra.branding_pref[1]? this.state.landing_extra.branding_pref[1] : "";
                data.broker_logo = this.state.landing_extra.landingpage_logo_image? this.state.landing_extra.landingpage_logo_image : "";
            }

            let query = queryString.stringify(data);
            test = test + query;
            window.open(test);
        }
    }

    _setLanding(){
        this.setState({
            renewLoader: true
        }, () => {
            dataRegister.setStatusLanding(salesChannelRegister.get('market'), this.state.landing_id, {active: !this.state.landing_status}).then((response) => {
                if (!response.errors) {
                    this.setState({
                        renewLoader: false,
                        landing_status: !this.state.landing_status
                    });
                } else {
                    this.setState({
                        renewLoader: false
                    });
                }
            }, (error) => {
                this.setState({
                    renewLoader: false
                });
            });
        });
    }

    _leads() {
        let leads = [];
        try {
            if (Array.isArray(this.state.landing_extra.leads)) {
                leads = this.state.landing_extra.leads;
            }
        } catch (e) {
        }
        return leads;
    }

    _engagement() {
        let engagement = [];
        try {
            if (Array.isArray(this.state.landing_extra.engagement)) {
                engagement = this.state.landing_extra.engagement;
            }
        } catch (e) {
        }
        return engagement;
    }

    _reactions() {
        let reactions = [];
        try {
            if (Array.isArray(this.state.reactions)) {
                reactions = this.state.reactions;
            }
        } catch (e) {
        }
        return reactions;
    }

    _theme() {
        let theme = "";
        try {
            if (this.state.landing_extra && this.state.landing_extra.theme) {
                theme = this.state.landing_extra.theme;
            }
        } catch (e) {
        }
        return theme;
    }

    _customCreatives() {
        let custom_creative = false;
        try {
            if (this.state.landing_extra && this.state.landing_extra.custom_creative) {
                custom_creative = this.state.landing_extra.custom_creative;
            }
        } catch (e) {
        }
        return custom_creative;
    }

    _totalBudget() {
        let total = 0;
        for (let key in this.state.budget) {
            total = total + this.state.budget[key];
        }
        return this._renderNumbers(Math.round(total));
    }

    _downloadObject(url, name){
        fetch(url)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = name;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(() => alert(this._renderText("item_121")));
    }

    _checkImage(url) {
        try {
        let request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.send();
        request.onload = function() {
            if (request.status == 200) {
                console.log("image exists");
                return true;
            } else {
                console.log("image doesn't exist");
                return false;
            }
        }
        } catch (e) {
            console.log("image doesn't exist");
            return false;
        }
    }

    render() {
        return (
            <div className={Styles.view}>
                {
                    this.state.renewModal &&
                    <ModalRenewHistory setAutorenew={this._autoRenew} props={this.props}/>
                }
                {
                    !this.state.isLoading &&
                    <div className={Styles.contentHeader}>
                        <div className={Styles.contentHeaderTitle}>
                            <div className={Styles.contentHeaderTitleInner}>
                                {this._renderText("item_2")}{" "}<span
                                className={Styles.contentHeaderTitleBold}>#{this.state.id}</span>{" "}{this._renderText("item_3")}{" "}
                                {
                                    this.state.end_date &&
                                    <span className={Styles.contentHeaderTitleBold}><Moment format="YYYY.MM.DD">
                                {this.state.end_date}
                            </Moment></span>
                                }
                            </div>
                        </div>
                        <LanguageButton props={this.props}/>
                        <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                            {this._renderText("item_1")}
                        </div>
                    </div>
                }
                <div className={Styles.container}>
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading &&
                        <div className={cx(Styles.tabsContainer)}>
                            <div onClick={() => this.setState({tab: "campaign", sub_tab: "general"})} className={
                                cx(Styles.tabsContainerItem,
                                    {
                                        [Styles.tabsContainerItemActive]: this.state.tab === "campaign",
                                    })
                            }>
                                {this._renderText("item_63")}
                            </div>
                            <div onClick={() => this.setState({tab: "landingpage", sub_tab: "general"})} className={
                                cx(Styles.tabsContainerItem,
                                    {
                                        [Styles.tabsContainerItemActive]: this.state.tab === "landingpage",
                                    })
                            }>
                                {window.innerWidth > 1050 ? this._renderText("item_64") : this._renderText("item_132")}
                            </div>
                            {
                                <div onClick={() => this.setState({tab: "media"})} className={
                                    cx(Styles.tabsContainerItem,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.tab === "media",
                                        })
                                }>
                                    {this._renderText("item_109")}
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.tab === "campaign" && this._reactions().length > 0 &&
                        <div className={Styles.tabsContainerOpposite}>
                            {
                                <div onClick={() => this.setState({sub_tab: "general"})} className={
                                    cx(Styles.tabsContainerItemOpposite,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.sub_tab === "general",
                                        })
                                }>
                                    {this._renderText("item_72")}
                                </div>
                            }
                            {
                                this._reactions().length > 0 &&
                                <div onClick={() => this.setState({sub_tab: "activity"})} className={
                                    cx(Styles.tabsContainerItemOpposite,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.sub_tab === "activity",
                                        })
                                }>
                                    {this._renderText("item_95")}
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.tab === "landingpage" && (this._leads().length > 0 || this._engagement().length > 0) &&
                        <div className={Styles.tabsContainerOpposite}>
                            {
                                <div onClick={() => this.setState({sub_tab: "general"})} className={
                                    cx(Styles.tabsContainerItemOpposite,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.sub_tab === "general",
                                        })
                                }>
                                    {this._renderText("item_72")}
                                </div>
                            }
                            {
                                this._leads().length > 0 &&
                                <div onClick={() => this.setState({sub_tab: "leads"})} className={
                                    cx(Styles.tabsContainerItemOpposite,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.sub_tab === "leads",
                                        })
                                }>
                                    {this._renderText("item_73")}
                                </div>
                            }
                            {
                                this._engagement().length > 0 &&
                                <div onClick={() => this.setState({sub_tab: "activity"})} className={
                                    cx(Styles.tabsContainerItemOpposite,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.sub_tab === "activity",
                                        })
                                }>
                                    {this._renderText("item_95")}
                                </div>
                            }
                        </div>
                    }
                    {
                        <div className={Styles.tabsSpace}></div>
                    }
                    {
                        !this.state.isLoading &&
                        <div className={Styles.summaryContainer}>
                            {
                                this.state.tab === "media" && this.state.landing_extra.yieldlock &&
                                <div>
                                    <div onClick={() => {
                                        this._getYieldlockData("seller");
                                    }} className={Styles.buttonBlack}>
                                        {this._renderText("item_110")}
                                    </div>
                                    <div onClick={() => {
                                        this._getYieldlockData("buyer");
                                    }} style={{marginBottom: 'calc(var(--size-factor) * 80px'}} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                        {this._renderText("item_111")}
                                    </div>
                                </div>
                            }

                            {
                                //false &&
                                this.state.tab === "media" && this.state.landing_extra && !this.state.landing_extra.yieldlock &&
                                <div>
                                    <div onClick={() => {
                                        this._getBoosterData();
                                    }} style={{marginBottom: 'calc(var(--size-factor) * 80px'}} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                        {this._renderText("item_117")}
                                    </div>
                                </div>
                            }

                            {
                                this.state.tab === "media" && this.state.video_url &&
                                <div className={Styles.contentInnerItem}>
                                    <div className={Styles.mediaDividerItem}>
                                        <div className={Styles.mediaDivider}>
                                            <div className={Styles.imagesContainerItemMedia}>
                                                <div className={Styles.imagesContainerItemInner}>
                                                    <video loop={true} muted={false} autoPlay={false} controls={true} poster={this.state.video_thumbnail}
                                                           style={{width: '100%', height: '100%'}}>
                                                        <source src={this.state.video_url} type="video/mp4"/>
                                                    </video>
                                                </div>
                                            </div>
                                            <div className={Styles.mediaDividerMediaButtons}>
                                                <div>
                                                    <div onClick={() => {
                                                        this._downloadObject(this.state.video_url, "video.mp4");
                                                        //window.open(this.state.video_url, '_blank');
                                                    }} style={{marginTop: '0px'}} className={Styles.buttonBlack}>
                                                        {this._renderText("item_112")}
                                                    </div>
                                                    <div onClick={() => {
                                                        window.open(this.state.video_url, '_blank');
                                                    }} style={{marginBottom: '0px'}} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                                        {this._renderText("item_118")}
                                                    </div>
                                                    {
                                                        false &&
                                                        <div onClick={() => {
                                                            window.open(this.state.video_url.replace('.mp4','.gif'), '_blank');
                                                        }} style={{marginBottom: '0px'}} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                                            {this._renderText("item_113")}
                                                        </div>
                                                    }
                                                </div>
                                                {
                                                    /*
                                                <div>
                                                    <a href={this.state.video_url} download={this.state.id + "_video.mp4"}>
                                                        <div style={{marginTop: '0px'}} className={Styles.buttonBlack}>
                                                            {this._renderText("item_112")}
                                                        </div></a>
                                                    <a href={this.state.video_url.replace('.mp4','.gif')} download={this.state.id + "_video.gif"}>
                                                        <div style={{marginBottom: '0px'}} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                                            {this._renderText("item_113")}
                                                        </div></a>

                                                </div>
                                                /*/
                                                }
                                                <div className={Styles.shareButtons}>
                                                    {
                                                        //false &&
                                                        <div onClick={() => {
                                                            window.open("https://wa.me/send?text=" + this.state.video_url, '_blank');
                                                        }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                             className={Styles.shareButton}>
                                                            <img className={Styles.shareButtonWhatsApp}
                                                                 src={require("../../assets/images/WhatsApp_white.svg")}/>
                                                        </div>
                                                    }
                                                    <div onClick={() => {
                                                        window.open("mailto:?Subject=" + this._renderText("item_115") + " | " + this.state.industry + " | " + this.state.advertising_name + " | #" + this.state.id + "&Body=" + this.state.video_url);
                                                    }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                         className={Styles.shareButton}>
                                                        <img className={Styles.shareButtonEmail}
                                                             src={require("../../assets/images/mail_icon_white.png")}/>
                                                    </div>
                                                    <div onClick={() => {
                                                        window.open(this.state.video_url, '_blank');
                                                    }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                         className={Styles.shareButton}>
                                                        <img className={Styles.shareButtonLink}
                                                             src={require("../../assets/images/link.svg")}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                this.state.tab === "media" && this.state.instagram_canvas &&
                                <div className={Styles.contentInnerItem}>
                                    <div className={Styles.mediaDividerItem}>
                                        <div className={Styles.mediaDivider}>
                                            <div className={Styles.imagesContainerItemMedia}>
                                                <img className={Styles.imagesContainerItemInner}
                                                     src={this.state.instagram_canvas}/>
                                            </div>
                                            <div className={Styles.mediaDividerMediaButtons}>
                                                <div>
                                                    <div onClick={() => {
                                                        this._downloadObject(this.state.instagram_canvas, "photo.jpg");
                                                        //window.open(this.state.instagram_canvas, '_blank');
                                                    }} style={{marginTop: '0px'}} className={Styles.buttonBlack}>
                                                        {this._renderText("item_114")}
                                                    </div>
                                                    <div onClick={() => {
                                                        window.open(this.state.instagram_canvas, '_blank');
                                                    }} style={{marginBottom: '0px'}} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                                        {this._renderText("item_120")}
                                                    </div>
                                                </div>
                                                <div className={Styles.shareButtons}>
                                                    {
                                                        //false &&
                                                        <div onClick={() => {
                                                            window.open("https://wa.me/send?text=" + this.state.instagram_canvas, '_blank');
                                                        }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                             className={Styles.shareButton}>
                                                            <img className={Styles.shareButtonWhatsApp}
                                                                 src={require("../../assets/images/WhatsApp_white.svg")}/>
                                                        </div>
                                                    }
                                                    <div onClick={() => {
                                                        window.open("mailto:?Subject=" + this._renderText("item_116") + " | " + this.state.industry + " | " + this.state.advertising_name + " | #" + this.state.id + "&Body=" + this.state.instagram_canvas);
                                                    }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                         className={Styles.shareButton}>
                                                        <img className={Styles.shareButtonEmail}
                                                             src={require("../../assets/images/mail_icon_white.png")}/>
                                                    </div>
                                                    <div onClick={() => {
                                                        window.open(this.state.instagram_canvas, '_blank');
                                                    }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                         className={Styles.shareButton}>
                                                        <img className={Styles.shareButtonLink}
                                                             src={require("../../assets/images/link.svg")}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                this.state.tab === "media" && this.state.facebook_canvas && !this._customCreatives() &&
                                <div className={Styles.contentInnerItem}>
                                    <div className={Styles.mediaDividerItem}>
                                        <div className={Styles.mediaDivider}>
                                            <div className={Styles.imagesContainerItemMediaRectangle}>
                                                <img className={Styles.imagesContainerItemInnerRectangle}
                                                     src={this.state.facebook_canvas}/>
                                            </div>
                                            <div className={Styles.mediaDividerMediaButtons}>
                                                <div>
                                                    <div onClick={() => {
                                                        this._downloadObject(this.state.facebook_canvas, "photo.jpg");
                                                       //window.open(this.state.facebook_canvas, '_blank');
                                                    }} style={{marginTop: '0px'}} className={Styles.buttonBlack}>
                                                        {this._renderText("item_114")}
                                                    </div>
                                                    <div onClick={() => {
                                                        window.open(this.state.facebook_canvas, '_blank');
                                                    }} style={{marginBottom: '0px'}} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                                        {this._renderText("item_120")}
                                                    </div>
                                                </div>
                                                <div className={Styles.shareButtons}>
                                                    {
                                                        //false &&
                                                        <div onClick={() => {
                                                            window.open("https://wa.me/send?text=" + this.state.facebook_canvas, '_blank');
                                                        }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                             className={Styles.shareButton}>
                                                            <img className={Styles.shareButtonWhatsApp}
                                                                 src={require("../../assets/images/WhatsApp_white.svg")}/>
                                                        </div>
                                                    }
                                                    <div onClick={() => {
                                                        window.open("mailto:?Subject=" + this._renderText("item_116") + " | " + this.state.industry + " | " + this.state.advertising_name + " | #" + this.state.id + "&Body=" + this.state.facebook_canvas);
                                                    }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                         className={Styles.shareButton}>
                                                        <img className={Styles.shareButtonEmail}
                                                             src={require("../../assets/images/mail_icon_white.png")}/>
                                                    </div>
                                                    <div onClick={() => {
                                                        window.open(this.state.facebook_canvas, '_blank');
                                                    }} style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                                         className={Styles.shareButton}>
                                                        <img className={Styles.shareButtonLink}
                                                             src={require("../../assets/images/link.svg")}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                this._leads().length > 0 &&
                                this.state.tab === "landingpage" && this.state.sub_tab === "leads" &&
                                this._leads().sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((item, index) => {
                                    return (
                                        <div className={Styles.summaryContainerItem}>
                                            <div style={{flexDirection:"row", display: "flex"}} className={Styles.summaryContainerItemTitle}>
                                                <Moment format="YYYY.MM.DD">
                                                    {item.timestamp}
                                                </Moment>
                                                {item.from_channel && item.from_channel !== "" && this._renderIcon(item.from_channel)}
                                                {
                                                    (salesChannelRegister.get("name") === "propertybooster" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#33B8CF", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/pb_logo_icon.svg")}/>
                                                    </div>
                                                }
                                                {
                                                    (salesChannelRegister.get("name") === "boostabostad" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#7ECF5B", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/bb_logo_icon.svg")}/>
                                                    </div>
                                                }
                                                {
                                                    (salesChannelRegister.get("name") === "yieldlock" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#00273A", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/yl_logo_icon.svg")}/>
                                                    </div>
                                                }
                                            </div>
                                            <div className={Styles.summaryContainerItemSummaryLeads}>
                                                {
                                                    item.picture &&
                                                    <div style={{marginRight: "15px"}}>
                                                        {
                                                        <div className={Styles.contentInnerItemHeaderImage} style={{position: "relative"}}>
                                                            <div className={Styles.contentInnerItemHeaderImageItem} style={{backgroundImage: "url(" + item.picture + ")", position: "absolute"}}/>
                                                            {
                                                                item.event !== "6" &&
                                                                <img className={Styles.contentInnerItemHeaderImageItem} src={require("../../assets/images/user_image_placeholder.jpg")}/>
                                                            }
                                                        </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.type &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_79")}
                                                            </span>
                                                        {
                                                            item.type === "1" &&
                                                            <span>
                                                                {this._renderText("item_80")}
                                                            </span>
                                                        }
                                                        {
                                                            item.type === "2" &&
                                                            <span>
                                                                {this._renderText("item_81")}
                                                            </span>
                                                        }
                                                        {
                                                            item.type === "3" &&
                                                            <span>
                                                                {this._renderText("item_93")}
                                                            </span>
                                                        }
                                                        {
                                                            item.type === "4" &&
                                                            <span>
                                                                {this._renderText("item_123")}
                                                            </span>
                                                        }
                                                        {
                                                            item.type === "5" &&
                                                            <span>
                                                                {this._renderText("item_147")}
                                                            </span>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.event &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_78")}
                                                            </span>
                                                        {
                                                            item.event === "1" &&
                                                            <span>
                                                                {this._renderText("item_82")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "2" &&
                                                            <span>
                                                                {this._renderText("item_83")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "3" &&
                                                            <span>
                                                                {this._renderText("item_84")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "4" &&
                                                            <span>
                                                                {this._renderText("item_85")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "5" &&
                                                            <span>
                                                                {this._renderText("item_86")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "6" &&
                                                            <span>
                                                                {this._renderText("item_89")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "7" &&
                                                            <span>
                                                                {this._renderText("item_90")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "8" &&
                                                            <span>
                                                                {this._renderText("item_91")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "9" &&
                                                            <span>
                                                                {this._renderText("item_92")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "10" &&
                                                            <span>
                                                                {this._renderText("item_96")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "11" &&
                                                            <span>
                                                                {this._renderText("item_97")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "12" &&
                                                            <span>
                                                                {this._renderText("item_98")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "13" &&
                                                            <span>
                                                                {this._renderText("item_99")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "14" &&
                                                            <span>
                                                                {this._renderText("item_100")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "15" &&
                                                            <span>
                                                                {this._renderText("item_105")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "16" &&
                                                            <span>
                                                                {this._renderText("item_106")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "18" &&
                                                            <span>
                                                                {this._renderText("item_124")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "19" &&
                                                            <span>
                                                                {this._renderText("item_127")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "20" &&
                                                            <span>
                                                                {this._renderText("item_129")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "21" &&
                                                            <span>
                                                                {this._renderText("item_130")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "22" &&
                                                            <span>
                                                                {this._renderText("item_131")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "23" &&
                                                            <span>
                                                                {this._renderText("item_140")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "24" &&
                                                            <span>
                                                                {this._renderText("item_141")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "25" &&
                                                            <span>
                                                                {this._renderText("item_142")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "26" &&
                                                            <span>
                                                                {this._renderText("item_143")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "27" &&
                                                            <span>
                                                                {this._renderText("item_144")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "28" &&
                                                            <span>
                                                                {this._renderText("item_145")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "29" &&
                                                            <span>
                                                                {this._renderText("item_146")}
                                                            </span>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.company &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_87")}
                                                            </span>
                                                        <span>
                                                                {item.company}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.website &&
                                                    <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_88")}
                                                            </span>
                                                        <span>
                                                                <a className={Styles.summaryContainerItemSummaryLinks} href={item.website.indexOf("https://") ? "https://" + item.website : item.website} target="_blank">
                                                                {item.website.toLowerCase()}
                                                                </a>
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.name &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_74")}
                                                            </span>
                                                        <span>
                                                                {item.name}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.email &&
                                                    <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_75")}
                                                            </span>
                                                        <a className={Styles.summaryContainerItemSummaryLinks} href={"mailto:" + item.email + "?Subject=" + this._renderText("item_77")} target="_top">
                                                            {item.email.toLowerCase()}
                                                        </a>
                                                    </div>
                                                }
                                                {
                                                    item.phone &&
                                                    <div style={{marginRight: "15px"}}>
                                                             <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_76")}
                                                        </span>
                                                        <a className={Styles.summaryContainerItemSummaryLinks} href={"tel:" + item.phone}>{item.phone}</a>
                                                    </div>
                                                }
                                                {
                                                    item.info &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_122")}
                                                            </span>
                                                        <span>
                                                                {item.info}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.other &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_128")}
                                                            </span>
                                                        <span>
                                                                {item.other}
                                                            </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                this._reactions().length > 0 &&
                                this.state.tab === "campaign" && this.state.sub_tab === "activity" &&
                                this._reactions().sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((item, index) => {
                                    return (
                                        <div className={Styles.summaryContainerItem}>
                                            <div style={{flexDirection:"row", display: "flex"}} className={Styles.summaryContainerItemTitle}>
                                                <Moment format="YYYY.MM.DD">
                                                    {item.timestamp}
                                                </Moment>
                                                {item.from_channel && item.from_channel !== "" && this._renderIcon(item.from_channel)}
                                                {
                                                    (salesChannelRegister.get("name") === "propertybooster" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#33B8CF", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/pb_logo_icon.svg")}/>
                                                    </div>
                                                }
                                                {
                                                    (salesChannelRegister.get("name") === "boostabostad" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#7ECF5B", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/bb_logo_icon.svg")}/>
                                                    </div>
                                                }
                                                {
                                                    (salesChannelRegister.get("name") === "yieldlock" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#00273A", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/yl_logo_icon.svg")}/>
                                                    </div>
                                                }
                                            </div>
                                            <div className={Styles.summaryContainerItemSummaryLeads}>
                                                {
                                                    item.picture &&
                                                    <div style={{marginRight: "15px"}}>
                                                        {
                                                            <div className={Styles.contentInnerItemHeaderImage} style={{position: "relative"}}>
                                                                <div className={Styles.contentInnerItemHeaderImageItem} style={{backgroundImage: "url(" + item.picture + ")", position: "absolute"}}/>
                                                                {
                                                                    <img className={Styles.contentInnerItemHeaderImageItem} src={require("../../assets/images/user_image_placeholder.jpg")}/>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.event &&
                                                    <div style={{marginRight: "15px"}}>
                                                        {
                                                            item.event === "1" &&
                                                            <span>
                                                                {this._renderText("item_102")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "2" &&
                                                            <span>
                                                                {this._renderText("item_103")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "3" &&
                                                            <span>
                                                                {this._renderText("item_104")}
                                                            </span>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.company &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_87")}
                                                            </span>
                                                        <span>
                                                                {item.company}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.website &&
                                                    <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_88")}
                                                            </span>
                                                        <span>
                                                                <a className={Styles.summaryContainerItemSummaryLinks} href={item.website.indexOf("https://") ? "https://" + item.website : item.website} target="_blank">
                                                                {item.website.toLowerCase()}
                                                                </a>
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.name &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_74")}
                                                            </span>
                                                        <span>
                                                                {item.name}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.email &&
                                                    <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_75")}
                                                            </span>
                                                        <a className={Styles.summaryContainerItemSummaryLinks} href={"mailto:" + item.email + "?Subject=" + this._renderText("item_77")} target="_top">
                                                            {item.email.toLowerCase()}
                                                        </a>
                                                    </div>
                                                }
                                                {
                                                    item.phone &&
                                                    <div style={{marginRight: "15px"}}>
                                                             <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_76")}
                                                        </span>
                                                        <a className={Styles.summaryContainerItemSummaryLinks} href={"tel:" + item.phone}>{item.phone}</a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                this._engagement().length > 0 &&
                                this.state.tab === "landingpage" && this.state.sub_tab === "activity" &&
                                this._engagement().sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((item, index) => {
                                    return (
                                        <div className={Styles.summaryContainerItem}>
                                            <div style={{flexDirection:"row", display: "flex"}} className={Styles.summaryContainerItemTitle}>
                                                <Moment format="YYYY.MM.DD">
                                                    {item.timestamp}
                                                </Moment>
                                                {item.from_channel && item.from_channel !== "" && this._renderIcon(item.from_channel)}
                                                {
                                                    (salesChannelRegister.get("name") === "propertybooster" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#33B8CF", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/pb_logo_icon.svg")}/>
                                                    </div>
                                                }
                                                {
                                                    (salesChannelRegister.get("name") === "boostabostad" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#7ECF5B", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/bb_logo_icon.svg")}/>
                                                    </div>
                                                }
                                                {
                                                    (salesChannelRegister.get("name") === "yieldlock" && (!item.from_channel || item.from_channel === "")) &&
                                                    <div style={{backgroundColor: "#00273A", marginLeft: "10px"}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                                                        <img className={Styles.cardSubtitleInnerIconsItemInternal} src={require("../../assets/images/yl_logo_icon.svg")}/>
                                                    </div>
                                                }
                                            </div>
                                            <div className={Styles.summaryContainerItemSummaryLeads}>
                                                {
                                                    item.picture &&
                                                    <div style={{marginRight: "15px"}}>
                                                        {
                                                            <div className={Styles.contentInnerItemHeaderImage} style={{position: "relative"}}>
                                                                <div className={Styles.contentInnerItemHeaderImageItem} style={{backgroundImage: "url(" + item.picture + ")", position: "absolute"}}/>
                                                                {
                                                                    item.event !== "6" &&
                                                                    <img className={Styles.contentInnerItemHeaderImageItem} src={require("../../assets/images/user_image_placeholder.jpg")}/>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.event &&
                                                    <div style={{marginRight: "15px"}}>
                                                        {
                                                            item.event === "1" &&
                                                            <span>
                                                                {this._renderText("item_82")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "2" &&
                                                            <span>
                                                                {this._renderText("item_83")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "3" &&
                                                            <span>
                                                                {this._renderText("item_84")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "4" &&
                                                            <span>
                                                                {this._renderText("item_85")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "5" &&
                                                            <span>
                                                                {this._renderText("item_86")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "6" &&
                                                            <span>
                                                                {this._renderText("item_89")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "7" &&
                                                            <span>
                                                                {this._renderText("item_90")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "8" &&
                                                            <span>
                                                                {this._renderText("item_91")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "9" &&
                                                            <span>
                                                                {this._renderText("item_92")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "10" &&
                                                            <span>
                                                                {this._renderText("item_96")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "11" &&
                                                            <span>
                                                                {this._renderText("item_97")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "12" &&
                                                            <span>
                                                                {this._renderText("item_98")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "13" &&
                                                            <span>
                                                                {this._renderText("item_99")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "14" &&
                                                            <span>
                                                                {this._renderText("item_100")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "15" &&
                                                            <span>
                                                                {this._renderText("item_105")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "16" &&
                                                            <span>
                                                                {this._renderText("item_106")}
                                                            </span>
                                                        }
                                                        {
                                                            item.event === "17" &&
                                                            <span>
                                                                {this._renderText("item_125")}
                                                            </span>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    item.company &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_87")}
                                                            </span>
                                                        <span>
                                                                {item.company}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.website &&
                                                    <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_88")}
                                                            </span>
                                                        <span>
                                                                <a className={Styles.summaryContainerItemSummaryLinks} href={item.website.indexOf("https://") ? "https://" + item.website : item.website} target="_blank">
                                                                {item.website.toLowerCase()}
                                                                </a>
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.name &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_74")}
                                                            </span>
                                                        <span>
                                                                {item.name}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.email &&
                                                    <div className={Styles.summaryContainerItemSummaryLinks} style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_75")}
                                                            </span>
                                                        <a className={Styles.summaryContainerItemSummaryLinks} href={"mailto:" + item.email + "?Subject=" + this._renderText("item_77")} target="_top">
                                                            {item.email.toLowerCase()}
                                                        </a>
                                                    </div>
                                                }
                                                {
                                                    item.phone &&
                                                    <div style={{marginRight: "15px"}}>
                                                             <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_76")}
                                                        </span>
                                                        <a className={Styles.summaryContainerItemSummaryLinks} href={"tel:" + item.phone}>{item.phone}</a>
                                                    </div>
                                                }
                                                {
                                                    item.info &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_122")}
                                                            </span>
                                                        <span>
                                                                {item.info}
                                                            </span>
                                                    </div>
                                                }
                                                {
                                                    item.reason &&
                                                    <div style={{marginRight: "15px"}}>
                                                            <span style={{marginRight: "5px"}} className={Styles.summaryContainerItemSummaryBold}>
                                                                {this._renderText("item_126")}
                                                            </span>
                                                        <span>
                                                                {item.reason}
                                                            </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_8")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {this._renderText("item_9")}{" "}
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.industry}{" "}</span>
                                        }
                                </span>
                                        {this._renderText("item_10")}{" "}
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                            {this.state.duration}{" "}
                            </span>
                                        {this._renderText("item_11")}
                                        {' '}
                                        {this._renderText("item_66")}
                                        {' '}
                                        {
                                            this.state.optimization === 2 &&
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {this._renderText("item_67")}
                                                    </span>
                                        }
                                        {
                                            this.state.optimization === 1 &&
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {this._renderText("item_68")}
                                                    </span>
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    {
                                        salesChannelRegister.get('name') !== 'yieldlock' && this._theme() !== "agency" &&
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_12")}
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') !== 'yieldlock' && this._theme() === "agency" &&
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_135")}
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name')==='yieldlock' &&
                                        <div className={Styles.summaryContainerItemTitle}>
                                            Yield
                                        </div>
                                    }
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {this._renderText("item_13")}{" "}
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.advertising_name}{" "}</span>
                                        }
                                </span>
                                        {this._renderText("item_14")}
                                    </div>
                                </div>
                            }

                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_15")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {this._renderText("item_16")}{" "}
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.phone}{" "}</span>
                                        }
                                </span>
                                        {this._renderText("item_17")}
                                    </div>
                                </div>
                            }
                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_18")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        <span>{this._renderText("item_19")}{" "}</span>
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            Object.keys(this.state.budget).map((key, i) => {
                                                return (
                                                    <span>
                                                          <span
                                                              className={Styles.summaryContainerItemSummaryChannel}>{this._renderChannelName(this._renderChannel(key))}</span>
                                                        {
                                                            i !== Object.keys(this.state.budget).length - 1 &&
                                                            <span>, </span>
                                                        }
                                                    </span>
                                                )
                                            })
                                        }
                                    </span>
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage && this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_136")}
                                    </div>
                                    {
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {
                                                !this.state.isLoadingFeed && this.state.feeds && this.state.feed_channels.length > 0 &&
                                                <span>{this._renderText("item_137")}{" "}</span>
                                            }
                                            {
                                                !this.state.feeds && this.state.feed_channels.length > 0 &&
                                                <span>{this._renderText("item_138")}{" "}</span>
                                            }
                                            {
                                                !this.state.isLoadingFeed && this.state.feeds && this.state.feed_channels.length < 1 &&
                                                <span>{this._renderText("item_139")}{" "}</span>
                                            }
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            this.state.feeds && !this.state.isLoadingFeed && this.state.feed_channels.map((key, i) => {
                                                return (
                                                    <span>
                                                          <span
                                                              className={Styles.summaryContainerItemSummaryChannel}>{this._renderFeedChannelName(key)}</span>
                                                        {
                                                            i !== this.state.feed_channels.length - 1 &&
                                                            <span>, </span>
                                                        }
                                                    </span>
                                                )
                                            })
                                        }
                                                {
                                                    !this.state.feeds && this.state.feed_channels.map((key, i) => {
                                                        return (
                                                            <span>
                                                  <span
                                                      className={Styles.summaryContainerItemSummaryChannel}>{this._renderFeedChannelName(key)}</span>
                                                                {
                                                                    i !== this.state.feed_channels.length - 1 &&
                                                                    <span>, </span>
                                                                }
                                            </span>
                                                        )
                                                    })
                                                }
                                    </span>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_20")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        <span>{this._renderText("item_21")}{" "}</span>
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                {this._renderLang(this.state.language)}
                            </span>
                                        {
                                            this.state.related_industries.length > 0 &&
                                            <span>.{" "}{this._renderText("item_22")}{" "}</span>
                                        }
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            this.state.related_industries.map((prop, key) => {
                                                if (key === this.state.related_industries.length - 1) {
                                                    return (
                                                        <span>{prop.name[langRegister.lang()]}</span>
                                                    )
                                                } else {
                                                    return (
                                                        <span>{prop.name[langRegister.lang()]}, </span>
                                                    )
                                                }
                                            })
                                        }
                                </span>
                                        <span>{this._renderText("item_23")}{" "}</span>
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            Object.keys(this.state.regions).map((prop, key) => {
                                                if (key === Object.keys(this.state.regions).length - 1) {
                                                    return (
                                                        <span>{this.state.regions[prop].name}</span>
                                                    )
                                                } else {
                                                    return (
                                                        <span>{this.state.regions[prop].name}, </span>
                                                    )
                                                }
                                            })
                                        }
                                </span>
                                    </div>
                                </div>
                            }
                            {
                                this.state.facebook_demographics && this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_24")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {
                                            (this.state.facebook_demographics.gender || (this.state.facebook_demographics.age_min && this.state.facebook_demographics.age_max))  &&
                                            <span>{this._renderText("item_25")}{" "}</span>
                                        }
                                        {
                                            !this.state.facebook_demographics.gender && (this.state.facebook_demographics.age_min && this.state.facebook_demographics.age_max) &&
                                            <span className={Styles.summaryContainerItemSummaryBold}>{this._renderSex("m")}, {this._renderSex("f")}{" "}</span>
                                        }
                                        {
                                            this.state.facebook_demographics.gender &&
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                                    {this._renderSex(this.state.facebook_demographics.gender)}
                                                {
                                                    !this.state.facebook_demographics.age_min && !this.state.facebook_demographics.age_max &&
                                                    <span>.</span>
                                                }
                                                {" "}
                                                </span>
                                        }
                                        {
                                            this.state.facebook_demographics.age_min && this.state.facebook_demographics.age_max &&
                                            <span>{this._renderText("item_26")}{" "}<span className={Styles.summaryContainerItemSummaryBold}>{this.state.facebook_demographics.age_min} - {this.state.facebook_demographics.age_max}</span>.{" "}</span>
                                        }
                                        {
                                            this.state.facebook_demographics.interests &&
                                            <span>{this._renderText("item_61")}{" "}
                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {
                                                            this.state.facebook_demographics.interests.map((prop, key) => {
                                                                if (key === this.state.facebook_demographics.interests.length - 1) {
                                                                    return (
                                                                        <span>{prop.name}</span>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <span>{prop.name}, </span>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </span>
                                                    .{" "}
                                                </span>
                                        }
                                        {
                                            this.state.facebook_demographics.behaviors &&
                                            <span>{this._renderText("item_65")}{" "}
                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {
                                                            this.state.facebook_demographics.behaviors.map((prop, key) => {
                                                                if (key === this.state.facebook_demographics.behaviors.length - 1) {
                                                                    return (
                                                                        <span>{prop.name}</span>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <span>{prop.name}, </span>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </span>
                                                    .{" "}
                                                </span>
                                        }
                                        {
                                            this.state.target_slogan &&
                                            <span>{this._renderText("item_62")}{" "}<span
                                                className={Styles.summaryContainerItemSummaryBold}>{this.state.target_slogan.trim()}.</span></span>
                                        }
                                        {
                                            this.renderKeywordLanguages().length > 1 &&
                                            <span>{this._renderText("item_69")}&nbsp;<span className={Styles.summaryContainerItemSummaryBold}>{
                                                this.renderKeywordLanguages().map((prop, key) => {
                                                    if (key === this.renderKeywordLanguages().length - 1) {
                                                        return (
                                                            <span>{this.renderKeywordLanguageTitle(prop)}</span>
                                                        )
                                                    } else {
                                                        return (
                                                            <span>{this.renderKeywordLanguageTitle(prop)},{" "}</span>
                                                        )
                                                    }
                                                })
                                            }</span></span>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                !this.state.facebook_demographics && this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_24")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {
                                            <span
                                                className={Styles.summaryContainerItemSummaryBold}>
                                                    {
                                                        this._renderText("item_71")
                                                    }
                                                </span>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    {
                                        this.state.smart_spend &&
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_27")}
                                        </div>
                                    }
                                    {
                                        this.state.smart_spend &&
                                        <div className={Styles.summaryContainerItemSummary}>
                                                <span>{this._renderText("item_28")}{" "}
                                                    <span className={Styles.summaryContainerItemSummaryBold}>{this._totalBudget()}{" "}{(this.state.currency).toUpperCase()}</span>{" "}{this._renderText("item_101")}{" "}{this._renderText("item_26")}
                                                </span>
                                            {
                                                Object.keys(this.state.budget).map((key, i) => {

                                                    return (
                                                        <span>
                                                            <span
                                                                className={Styles.summaryContainerItemSummaryChannel}>{" "}{this._renderChannelName(this._renderChannel(key))}</span>
                                                            {
                                                                i !== Object.keys(this.state.budget).length - 1 &&
                                                                <span>,{" "}</span>
                                                            }
                                                    </span>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    {
                                        !this.state.smart_spend &&
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_27")}
                                        </div>
                                    }
                                    {
                                        !this.state.smart_spend &&
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <span>{this._renderText("item_28")}{" "}</span>
                                            {
                                                Object.keys(this.state.budget).map((key, i) => {

                                                    return (
                                                        <span>
                                                        <span
                                                            className={Styles.summaryContainerItemSummaryBold}>{this._renderNumbers(Math.round(this.state.budget[key]))}{" "}{(this.state.currency).toUpperCase()}</span>
                                                            {" "}{this._renderText("item_29")}
                                                            <span
                                                                className={Styles.summaryContainerItemSummaryChannel}>{" "}{this._renderChannelName(this._renderChannel(key))}</span>
                                                            {
                                                                i !== Object.keys(this.state.budget).length - 1 &&
                                                                <span>,{" "}</span>
                                                            }
                                                    </span>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.state.landingpage && this.state.tab === "landingpage" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_30")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        <div onClick={() => this._goLanding()}
                                             className={Styles.summaryContainerItemLink}>
                                            https://lp.{dataRegister.domain}/{this.state.landingpage_url}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.website && this.state.tab === "landingpage" && this.state.sub_tab === "general" &&
                                <div className={
                                    cx(Styles.summaryContainerItem,
                                        {
                                            [Styles.tabsContainerItemNoBorder]: !this.state.landingpage
                                        })
                                }>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_30")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        <div onClick={() => this._goLanding()}
                                             className={Styles.summaryContainerItemLink}>
                                            {this.state.website}
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage && this.state.tab === "landingpage" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_31")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {this._renderText("item_32")}{" "}
                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.landingpage_phone}{" "}</span>
                                        }
                                </span>
                                        {this._renderText("item_33")}
                                    </div>
                                </div>
                            }
                            {
                                this.state.landingpage && this.state.tab === "landingpage" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_34")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {this._renderText("item_35")}{" "}<span
                                        className={Styles.summaryContainerItemSummaryBold}>{this.state.landingepage_address}</span>{" "}{this._renderText("item_36")}
                                    </div>
                                </div>

                            }
                            {
                                this.state.landingpage && this.state.tab === "landingpage" && this.state.sub_tab === "general" &&
                                <div className={
                                    cx(Styles.summaryContainerItem,
                                        {
                                            [Styles.tabsContainerItemNoBorder]: !this.state.landingpage
                                        })
                                }>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_37")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        {this._renderText("item_38")}{" "}<span
                                        className={Styles.summaryContainerItemSummaryBold}>{this.state.landingpage_email}</span>{" "}{this._renderText("item_39")}
                                    </div>
                                </div>

                            }
                            {
                                this.state.landingpage && this.state.tab === "landingpage" && this.state.sub_tab === "general" &&
                                <div className={
                                    cx(Styles.summaryContainerItem,
                                        {
                                            [Styles.tabsContainerItemNoBorder]: this.state.landingpage
                                        })
                                }>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        Status
                                    </div>
                                    <div className={cx(Styles.summaryContainerItemAutoRenew)}>
                                        {
                                            !this.state.renewLoader &&
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={Styles.summaryContainerItemSummaryBold}>
                                                {this._renderText("item_41")}
                                            </div>
                                        }
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' &&
                                            (this.state.landing_status && !this.state.renewLoader) &&
                                            <img onClick={() => this._setLanding()}
                                                 className={Styles.summaryContainerItemAutoRenewIcon}
                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' &&
                                            (this.state.landing_status && !this.state.renewLoader) &&
                                            <img onClick={() => this._setLanding()}
                                                 className={Styles.summaryContainerItemAutoRenewIcon}
                                                 src={require("../../assets/images/slider_active_yl.svg")}/>
                                        }
                                        {
                                            !this.state.landing_status && !this.state.renewLoader &&
                                            <img onClick={() => this._setLanding()}
                                                 className={Styles.summaryContainerItemAutoRenewIcon}
                                                 src={require("../../assets/images/slider_deactive.svg")}/>
                                        }
                                        {
                                            this.state.renewLoader &&
                                            <BeatLoader size={15} color={'#000000'} loading={true}/>
                                        }
                                        {
                                            !this.state.renewLoader &&
                                            <div
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={Styles.summaryContainerItemSummaryBold}>
                                                {this._renderText("item_42")}
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div className={Styles.summaryContainerItem}>
                                    <div className={Styles.summaryContainerItemTitle}>
                                        {this._renderText("item_59")}
                                    </div>
                                    <div className={Styles.summaryContainerItemSummary}>
                                        <span>{this._renderText("item_60")}{" "}</span>
                                        <span
                                            className={Styles.summaryContainerItemSummaryBold}>{this.state.email}</span>
                                    </div>
                                </div>
                            }

                            {
                                this.state.tab === "campaign" && this.state.sub_tab === "general" &&
                                <div>
                                    <div className={Styles.dividerTop}/>
                                    <div onClick={() => this._selectInvoice()} className={Styles.buttonBlack}>
                                        {this._renderText("item_43")}
                                    </div>
                                    <div onClick={() => this._selectSummary()} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                        {this._renderText("item_47")}
                                    </div>
                                    <div onClick={() => this._selectReport()} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                        {this._renderText("item_46")}
                                    </div>
                                    {
                                        !this.state.renew && this.state.tab === "campaign" && this.state.sub_tab === "general" && this.state.restart &&
                                        <div>
                                            <div className={Styles.divider}/>
                                            <div onClick={() => this._setRenew()} style={salesChannelRegister.get('name') === "yieldlock"?{backgroundColor: '#E65032'}:{}} className={Styles.buttonRed}>
                                                {
                                                    !this.state.renewLoader &&
                                                    this._renderText("item_44")
                                                }
                                                {
                                                    this.state.renewLoader &&
                                                    <BeatLoader size={15} color={'#ffffff'} loading={true}/>
                                                }
                                            </div>
                                        </div>
                                    }
                                    <div onClick={() => {
                                        this._back();
                                    }} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.backButton}>
                                        {this._renderText("item_45")}
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default userCampaignsHistoryEdit


// WEBPACK FOOTER //
// ./src/components/user-campaigns-history-edit/component.js